import { Link } from 'react-router-dom';
import { Settings as SettingsIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import ThemeToggle from './ThemeToggle';
import NotificationBell from './NotificationBell';
import { LogoCompact } from './Logo';

const MobileHeader = ({ isDashboard = false }) => {
  const { user } = useAuth();

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md border-b md:hidden"
      style={{ background: 'var(--bg-secondary)', borderColor: 'var(--border-color)' }}
    >
      <div className="px-4 py-3">
        <div className="flex items-center justify-between gap-2">
          {/* Logo (already includes the "Phantom Trades" wordmark) */}
          <Link to={user ? '/dashboard' : '/'} className="flex items-center min-w-0">
            <LogoCompact />
          </Link>

          {/* Right cluster: Notifications, Theme, Settings */}
          <div className="flex items-center gap-1 shrink-0 relative z-10">
            {isDashboard && user && <NotificationBell />}
            <ThemeToggle />
            {isDashboard && user && (
              <Link
                to="/settings"
                aria-label="Open settings"
                className="p-2 rounded-full text-gray-300 hover:text-white hover:bg-white/5 transition-colors focus:outline-none focus-visible:outline-none"
                data-testid="mobile-header-settings-link"
              >
                <SettingsIcon className="h-5 w-5" />
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default MobileHeader;
